var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gantt-iframe",attrs:{"id":_vm.options.id}},[(_vm.getDataResult)?_c('gantt-mask'):_vm._e(),_c('iframe',{attrs:{"src":_vm.getSrc()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }